import { useState } from "react";
import { usePageSeo } from "@/hooks/usePageSeo";
import { PageHero } from "@/components/common/PageHero";
import { FAQAccordion } from "@/components/common/FAQAccordion";
import { Input } from "@/components/ui/input";
import { FAQ_GROUPS, FAQ_GROUPS_AR } from "@/lib/content";
import { useLang } from "@/context/LanguageContext";
import { Search as SearchIcon } from "lucide-react";

export default function FAQ() {
  const { L, isAr } = useLang();
  const GROUPS = isAr ? FAQ_GROUPS_AR : FAQ_GROUPS;
  usePageSeo("faq", {
    jsonLd: {
      "@context": "https://schema.org", "@type": "FAQPage",
      mainEntity: FAQ_GROUPS.flatMap((g) => g.items).map((i) => ({
        "@type": "Question", name: i.q, acceptedAnswer: { "@type": "Answer", text: i.a },
      })),
    },
  });
  const [q, setQ] = useState("");
  const groups = GROUPS.map((g) => ({
    ...g,
    items: g.items.filter((it) => (it.q + it.a).toLowerCase().includes(q.toLowerCase())),
  })).filter((g) => g.items.length);

  return (
    <>
      <PageHero
        overline={L.pages.faq.overline}
        title={L.pages.faq.title}
        description={L.pages.faq.desc}
        breadcrumbs={[{ label: L.common.home, to: "/" }, { label: L.pages.faq.overline }]}
      />

      <section className="py-16 lg:py-24">
        <div className="container-tight max-w-4xl">
          <div className="relative mb-10">
            <SearchIcon className="absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={L.pages.faq.searchPlaceholder} className="ps-9" data-testid="faq-search" />
          </div>
          {groups.length ? groups.map((g) => (
            <div key={g.title} className="mb-10">
              <h2 className="mb-4 font-heading text-xl font-semibold text-ink">{g.title}</h2>
              <FAQAccordion items={g.items} idPrefix={`faq-${g.title.toLowerCase()}`} />
            </div>
          )) : <p className="py-16 text-center text-subtle">{L.pages.faq.noResults}</p>}
        </div>
      </section>
    </>
  );
}
